import * as Checkbox from '@radix-ui/react-checkbox';
import cn from 'classnames';
import { BsCheck } from 'react-icons/bs';
type CheckboxParams = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  classNames?: string;
};

const CustomCheckbox = ({ checked, onChange, label, classNames }: CheckboxParams) => (
  <div className="flex flex-row justify-between items-center my-3">
    {label && <label className="text-secondary">{label}</label>}
    <Checkbox.Root
      className={cn(
        'bg-white rounded-lg border border-primary shadow-sm w-8 h-8 flex items-center justify-center',
        classNames,
      )}
      defaultChecked={checked}
      onCheckedChange={(checked) => {
        if (onChange) onChange(typeof checked === 'boolean' ? checked : false);
      }}
    >
      <Checkbox.Indicator className="text-primary">
        <BsCheck size={24} />
      </Checkbox.Indicator>
    </Checkbox.Root>
  </div>
);

export default CustomCheckbox;
